import React from 'react';
import RoutesApp from './RoutesApp';
import './App.css';
import Header from './nav/Header';

const App = () =>{
  return (
     <div>
       <Header />
       <RoutesApp />
     </div>
       
  );
}

export default App;
